export const tooltipPreset = {
  tooltip: {
    root: {
      maxWidth: '380px',
      borderRadius: '0.5rem',
    },
    colorScheme: {
      light: {
        root: {
          background: '#181D27',
          color: '#ffffff',
        },
      },
    },
    css: () => `
      .p-tooltip-text {
        padding: 0.5rem 0.75rem;
        border-radius: 0.5rem;
      }

      /* Arrow - TOP */
      .p-tooltip-top .p-tooltip-arrow {
        border-top-color: #181D27;
      }

      /* Arrow - BOTTOM */
      .p-tooltip-bottom .p-tooltip-arrow {
        border-bottom-color: #181D27;
      }

      /* Arrow - LEFT */
      .p-tooltip-left .p-tooltip-arrow {
        border-left-color: #181D27;
      }

      /* Arrow - RIGHT */
      .p-tooltip-right .p-tooltip-arrow {
        border-right-color: #181D27;
      }

      .form-census .p-inputgroup {
        position: relative;
      }

      .form-census .info-icon {
        position: relative;
        right: 16px;
        top: -31px;
        float: right;
        color: var(--neutral--30);
      }

      .form-census .tooltip-datepicker {
        right: 50px;
      }
    `,
  },
};
